// extracted by mini-css-extract-plugin
export default {"container":"CustomLexiconContainer_container__t2TOA"};